import { gql } from '@apollo/client'
import allFeatureFlagsFragment from 'graphql/fragments/allFeatureFlagsFragment'
import sideMenuFragment from 'graphql/fragments/sideMenuFragment'

import blogPost from '../fragments/blogPostFragment'

const getPublicBlogPostQuery = gql`
  query GetPublicBlogPost($slug: String!, $marketId: ID!) {
    market(id: $marketId) {
      id
      ...blogPost
    }
  }
  ${blogPost}
`

export const PREFETCH_PUBLIC_BLOG_POST = gql`
  query PrefetchPublicBlogPost(
    $slug: String!
    $marketId: ID!
    $profilesPerCollection: Int! = 7
  ) {
    market(id: $marketId) {
      id
      ...blogPost
      ...sideMenuFragment
    }
    ...allFeatureFlagsFragment
  }
  ${blogPost}
  ${sideMenuFragment}
  ${allFeatureFlagsFragment}
`

export default getPublicBlogPostQuery
